export const POLLING_INTERVAL_MS = 1000
export const MAX_POLLING_ATTEMPTS = 120
